const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
const INITIAL_DELAY_MS = 300;

export const MAX_DELAY_MS = 600000;

export const backOff = (
  callback,
  isResultOk,
  maxDelay,
  initialDelay = INITIAL_DELAY_MS,
) => {
  let currentDelay = initialDelay;

  return async function recursion() {
    const result = await callback();

    if (!isResultOk(result) && currentDelay <= maxDelay) {
      await delay(currentDelay);
      currentDelay *= 2;
      return recursion();
    }

    return result;
  };
};
